export const sendStartupMetrics = async metrics => {
  //TODO: cual es la licencia
  const NEW_RELIC_INSERT_KEY = '77964f0461739aa4767525178ef4f474FFFFNRAL';
  const ACCOUNT_ID = '675452';
  const url = `https://insights-collector.newrelic.com/v1/accounts/${ACCOUNT_ID}/events`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Insert-Key': NEW_RELIC_INSERT_KEY,
      },
      body: JSON.stringify([metrics]),
    });
    if (response.ok) {
      console.log('AppStartup metrica enviada');
      sessionStorage.setItem('sendedStartupMetrics', true);
    }
  } catch (error) {
    sessionStorage.setItem('sendedStartupMetrics', true);
    console.error('Fallo en la peticion a New Relic:', error);
  }
};
